import React from 'react';
import LoginForm from '../components/auth/LoginForm';

const LoginPage = () => {
  // Afficher toujours le formulaire de connexion
  // Ne plus rediriger automatiquement même si l'utilisateur est connecté
  return <LoginForm />;
};

export default LoginPage;